import { MutationTree } from 'vuex'
import { ThemeState } from './state'
import { Theme } from '~/constants/theme/theme'
import { SET_ACTIVE_THEME } from '~/store/modules/shared/theme/mutation-types'

export default {
  [SET_ACTIVE_THEME](state, theme: Theme) {
    state.activeTheme = theme
  }
} as MutationTree<ThemeState>
